import { render, staticRenderFns } from "./FormulaEditor.vue?vue&type=template&id=2f1df132&scoped=true&lang=html&"
import script from "./FormulaEditor.vue?vue&type=script&lang=js&"
export * from "./FormulaEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormulaEditor.vue?vue&type=style&index=0&id=2f1df132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1df132",
  null
  
)

export default component.exports